import React, {useState} from 'react'
import {useReservationFormState} from '../hooks'
import {
	CalendarInputPanel,
	DetailsDateRage,
	DetailsHeaderPanel,
	DetailsImagePanel,
} from './Components'

export const BasicDetails = ({
	onClick,
	contract,
}: {
	onClick?: () => void
	contract: Pick<Contract, 'house' | 'beginDate' | 'endDate'>
}) => {
	const {house} = contract || {}

	return (
		<div className="flex flex-col gap-12 lg:flex-row">
			<DetailsImagePanel house={house} />
			<div className="flex w-full flex-col gap-4">
				<DetailsHeaderPanel contract={contract} />
				<DetailsDateRage contract={contract} onClick={onClick} />
			</div>
		</div>
	)
}

const ReservationDetails = () => {
	const [showCalendar, setShowCalendar] = useState(false)
	const {formValue} = useReservationFormState()
	const {contract} = formValue || {}

	const toggleCalendarView = () => {
		setShowCalendar(showCalendar => !showCalendar)
	}

	return (
		<div className="bg-capGoldLight flex w-full flex-col gap-8 rounded-lg p-8">
			<BasicDetails contract={contract} onClick={toggleCalendarView} />
			{showCalendar && <CalendarInputPanel />}
		</div>
	)
}

export default ReservationDetails
